(ns renolit-roofing-service.layout.user-layout
  (:require [re-frame.core :as rf]
            [renolit-roofing-service.layout.dropdown-menu :as layout.dropdown-menu]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.layout.notifications :as notifications]
            [renolit-roofing-service.layout.sidebar :as sidebar]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.mobile :as mobile]))

(def ^:private default-header-end
  [notifications/main])

(defn- hamburger-button
  [opts _args]
  [:div.hamburger-menu
   opts
   [layout.icon/icon
    {:class "hamburger-menu-btn"
     :key :menu}]])

(defn- hamburger-panel
  [opts _args children]
  [:div (update opts :className str " hamburger-menu__panel")
   children])

(defn- header
  [{:keys [header-start header-title-kw header-title header-end]}]
  (let [mobile? @(rf/subscribe [::mobile/mobile?])]
    [:div.user_layout_header
     (or header-start
         [:h1.user_layout_header_title (or (t [header-title-kw]) header-title)])
     [:div.user_layout_header__actions
      (when mobile?
        [:> layout.dropdown-menu/menu
         {:placement "bottom-end"
          :reference {:component hamburger-button}
          :floating {:component hamburger-panel}}
         [sidebar/hamburger-menu-items]])
      (or header-end default-header-end)]]))

(defn main
  [opts & children]
  (into
   [:div.user_layout
    [header opts]]
   children))
